import { render } from "./UploadButton.vue?vue&type=template&id=8fa76c12&scoped=true&ts=true"
import script from "./UploadButton.vue?vue&type=script&lang=ts"
export * from "./UploadButton.vue?vue&type=script&lang=ts"

import "./UploadButton.vue?vue&type=style&index=0&id=8fa76c12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fa76c12"]])

export default __exports__